import { LocalStorageService } from 'angular-2-local-storage';
import { AppTranslateService } from './translations/services/app-translation.service';
import { TranslateLoader, MissingTranslationHandler, TranslateService } from '@ngx-translate/core';
import { MyMissingTranslationHandler } from './translations/services/app-missingTranslation.service';
import { CacheKey } from './shared/constants/cachekey.constants';
import { SharedConstants } from './shared/constants/shared.constants';
import { HttpClient } from '@angular/common/http';
export function createTranslateLoader(http, localStorage) {
    return new AppTranslateService(http, localStorage);
}
const ɵ0 = (createTranslateLoader);
const translationOptions = {
    loader: {
        provide: TranslateLoader,
        useFactory: ɵ0,
        deps: [HttpClient, LocalStorageService]
    },
    missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: MyMissingTranslationHandler
    }
};
export class AppModule {
    constructor(translate, localStorageService, _cacheService) {
        this.translate = translate;
        this.localStorageService = localStorageService;
        this._cacheService = _cacheService;
        this.defaultlang = this.localStorageService.get('DefaultLanguage');
        this.language = this._cacheService.getCookieValue(CacheKey.languageCode);
        const eventPage = SharedConstants.EVENT_PAGES.find((page) => {
            return window.location.href.toLowerCase().indexOf(page.toLowerCase()) > -1;
        });
        if (!eventPage) {
            if (this.language) {
                this.translate.use(this.language);
            }
            else if (this.defaultlang) {
                this.translate.use(this.defaultlang);
            }
        }
        else {
            this.translate.use('en-US');
        }
    }
}
export { ɵ0 };
